'use client'

// Кнопки озвучки в едином виде по всему приложению (задачи 82-83 из Telegram, 09.10).
// ListenPill - подписанная кнопка как «Слушать» у слова урока (word-audio-row.tsx):
// до нажатия прозрачная, после нажатия синяя.
// OrbAudioButton - значок-шарик в строке (реплика, фраза): остаётся значком,
// после нажатия обводится синим кольцом.
// heardKey - что озвучивает кнопка (обычно турецкий текст): сменился текст на том
// же месте экрана (следующее упражнение) - подсветка снимается сама.
import { useState, type ReactNode } from 'react'
import { AudioOrbIcon } from '@/components/audio-orb-icon'

export function useHeard(heardKey: string) {
  const [heardFor, setHeardFor] = useState<string | null>(null)
  return [heardFor === heardKey, () => setHeardFor(heardKey)] as const
}

export function ListenPill({
  heardKey,
  onClick,
  children,
  disabled,
  dimmed,
  slow,
  ariaLabel,
  title,
}: {
  heardKey: string
  onClick: () => void
  /** Без подписи - круглая кнопка-значок (медленная озвучка с черепашкой). */
  children?: ReactNode
  disabled?: boolean
  dimmed?: boolean
  slow?: boolean
  ariaLabel?: string
  title?: string
}) {
  const [heard, markHeard] = useHeard(heardKey)
  return (
    <button
      type="button"
      // Только значок, подпись для экранного диктора (владелец 15.10.2026: кнопки
      // озвучки и записи во всём приложении значками, без плашек с текстом).
      className="tk-pill-toggle tk-pill-listen tk-pill-icon"
      disabled={disabled}
      aria-label={ariaLabel}
      title={title}
      data-on={heard ? '' : undefined}
      onClick={() => {
        markHeard()
        onClick()
      }}
    >
      <AudioOrbIcon size={36} dimmed={dimmed} slow={slow} />
      {children && <span className="sr-only">{children}</span>}
    </button>
  )
}

export function OrbAudioButton({
  heardKey,
  onClick,
  disabled,
  ariaLabel,
  title,
  size = 22,
  slow,
}: {
  heardKey: string
  onClick: () => void
  disabled?: boolean
  ariaLabel?: string
  title?: string
  size?: number
  slow?: boolean
}) {
  const [heard, markHeard] = useHeard(heardKey)
  return (
    <button
      type="button"
      className="tk-bubble-audio-btn"
      disabled={disabled}
      aria-label={ariaLabel}
      title={title}
      data-heard={heard ? '' : undefined}
      style={size === 22 ? undefined : { width: size, height: size }}
      onClick={() => {
        markHeard()
        onClick()
      }}
    >
      <AudioOrbIcon size={size} slow={slow} />
    </button>
  )
}
